import { createI18n } from 'vue-i18n';
import { Language } from '@/common/constants/languages';

export default createI18n({
  locale: localStorage.getItem('currentLanguage') || Language.en,
});
